import PropTypes from "prop-types";
import {CCard, CCardBody, CCardHeader, CCardLink, CCardTitle,} from "@coreui/react";

import "@coreui/coreui/dist/css/coreui.min.css";

function MenuCard({menuItem}) {
    return (
        <CCard
            className="w-80 h-auto shadow-sm hover:shadow-md transition-all duration-200 rounded-xl border border-gray-200 bg-white">
            <CCardHeader
                className="bg-gradient-to-r from-blue-500 to-blue-700 text-white text-center text-lg font-semibold py-3 rounded-t-xl tracking-wide">
                {menuItem.title}
            </CCardHeader>

            <CCardBody className="px-5 py-4">
                {menuItem.subtitle && (
                    <CCardTitle className="text-gray-600 text-center text-base font-medium mb-3">
                        {menuItem.subtitle}
                    </CCardTitle>
                )}

                {menuItem.links?.length > 0 && (
                    <div className="flex flex-col items-center gap-2">
                        {menuItem.links.map((link) => (
                            <CCardLink
                                key={link.url}
                                href={link.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-600 hover:text-blue-800 underline transition-colors text-sm">
                                {link.text}
                            </CCardLink>
                        ))}
                    </div>
                )}
            </CCardBody>
        </CCard>
    );
}

MenuCard.propTypes = {
    menuItem: PropTypes.shape({
        title: PropTypes.string.isRequired,
        subtitle: PropTypes.string,
        links: PropTypes.arrayOf(
            PropTypes.shape({
                url: PropTypes.string.isRequired,
                text: PropTypes.string.isRequired,
            })
        ),
    }).isRequired,
};

export default MenuCard;
